import axios, { AxiosResponse } from 'axios';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { ResetPasswordRequest } from '../../../../models/authentication/ResetPasswordRequest';
import { F1ResetPasswordResponse } from '../../../../models/authentication/F1ResetPasswordResponse';

export function useF1ValidateChangePassword(
    options?: UseMutationOptions<F1ResetPasswordResponse[], Error, ResetPasswordRequest>
) {
    return useMutation({
        mutationFn: async (request: ResetPasswordRequest) => {
            const response: AxiosResponse<F1ResetPasswordResponse[]> = await axios.put('/v1/f1/employee/password/validate', request)
            return response.data
        },
        ...options
    });
}
